import { useState, type FormEvent } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@shared/auth/AuthContext";
import { Button } from "@shared/components/Button";
import { TextField } from "@shared/components/TextField";

/** Only same-site paths, so a crafted link cannot bounce the admin to another origin after login. */
function safeTarget(from: unknown): string {
  return typeof from === "string" && from.startsWith("/") && !from.startsWith("//") && from !== "/login"
    ? from
    : "/articles";
}

export function LoginPage() {
  const { status, login } = useAuth();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (status === "authenticated") {
    return <Navigate to={safeTarget((location.state as { from?: unknown } | null)?.from)} replace />;
  }

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    if (submitting) return;
    if (!username.trim() || !password) {
      setError("Username atau email dan kata sandi wajib diisi.");
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      await login(username.trim(), password);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Gagal masuk. Coba lagi.");
      setPassword("");
      setSubmitting(false);
    }
  }

  return (
    <div className="center-screen">
      <form className="card login-card" onSubmit={onSubmit} noValidate>
        <h1>Persona Admin</h1>
        <p className="muted">Masuk dengan akun admin.</p>
        <TextField
          label="Username atau email"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
          autoCapitalize="none"
        />
        <TextField
          label="Kata sandi"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
        />
        {error && (
          <p role="alert" className="form-error">
            {error}
          </p>
        )}
        <Button type="submit" disabled={submitting}>
          {submitting ? "Memproses…" : "Masuk"}
        </Button>
      </form>
    </div>
  );
}
